module.exports = __webpack_public_path__ + "mstile-310x150.png";